// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__seSxK","largestCol":"styles_largestCol__2U_zN","smallestCol":"styles_smallestCol___Nh5v"};